import { authorize, postRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

export async function submitContactInfoAPI(contactInfo) {
  const backendURL = `${AWS_API_URL}/feedback`;

  return postRequest(backendURL, { data: contactInfo }, await authorize());
}
